import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  TableCell,
  TableRow,
  IconButton,
  Box,
  Chip,
  Button,
  makeStyles,
} from '@material-ui/core';
import { Delete, Edit } from '@material-ui/icons';
import ModalBarcode from '../common/ModalBarcode';
import StatusKey from '../common/StatusKey';
import CommentIcon from '@material-ui/icons/Comment';
import { HouseKeyComments } from '../HousekeyComments';
import { RolePermissions } from '../../domain/constants/RolePremissions';
import { SystemActions } from '../../domain/constants/SystemActions';
import { useSelector } from 'react-redux';
import AccessAlarmsIcon from '@material-ui/icons/AccessAlarms';
import AddIcCallIcon from '@material-ui/icons/AddIcCall';
import { fullTime, relativeFutureTime } from '../../helpers/datetime';
import { Housekey } from '../../redux/housekeys/models/Housekey';

import moment from 'moment';
import Swal from 'sweetalert2';
import { deleteKeyService } from 'src/redux/drawers/apis';
import { RolesIds } from 'src/domain/constants/Roles';
import { useAppDispatch } from 'src/redux/hooks';
import { removeKeyById } from 'src/redux/housekeys/slice';

export const useSyles = makeStyles({
  user_info: {
    display: 'flex',
    paddingTop: 1,
    paddingBottom: 1,
    color: '#144D66',
    gap: '8px',
    flexDirection: 'column',
  },
});

const HousekeyRow = ({ housekey }: { housekey: Housekey }) => {
  console.log('xxxx housekey', housekey);
  const classes = useSyles();
  const { auth } = useSelector((state: any) => state);
  const allowEdit = RolePermissions.allowed(
    Number(auth.type),
    SystemActions.edit_keys
  );
  const {
    properties_nid,
    barcode,
    type_keys_str,
    id,
    created_at,
    status_keys_id,
    status_keys_str,
    user_name,
    user_area,
    user_phone,
    user_email,
    comments_number,
    serial_number,
  } = housekey;
  const isExceededLoan = Number(housekey.loan?.days_past_due) < 0;

  const dispatchRedux = useAppDispatch();
  const navigate = useNavigate(); // habilitar navigate para redirección
  const [showBarcode, setShowBarcode] = useState(false);
  const [selectedHouseKeyId, setSelectedHouseKeyId] = useState<number | null>(
    null
  );

  // función que redirige de forma programada
  const redirectEdition = (id: number) => {
    navigate(`/housekeys/edit/${id}`, { replace: true });
  };

  const openCommentHandler = (id: any): void => {
    setSelectedHouseKeyId(id);
  };

  const closeCommentHandler = (): void => {
    setSelectedHouseKeyId(null);
  };

  const deleteKey = async () => {
    try {
      await deleteKeyService(housekey.id);
      dispatchRedux(
        removeKeyById({
          id: housekey.id,
        })
      );
      Swal.fire({
        title: 'Se eliminó la llave.',
        icon: 'success',
      });
    } catch (error) {
      Swal.fire({
        title: 'Hubo un error, inténtalo de nuevo.',
        icon: 'error',
      });
    }
  };

  return (
    <TableRow key={`housekey-row-${id}`}>
      <TableCell component='th' scope='row'>
        {id}
      </TableCell>
      <TableCell>{properties_nid}</TableCell>
      <TableCell>
        <p>{type_keys_str}</p>
        {type_keys_str === 'Chapa electronica' && (
          <p>SN: {serial_number ? serial_number : '-'}</p>
        )}
      </TableCell>
      <TableCell>
        <Box sx={{ textAlign: 'center', width: 'max-content', margin: 'auto' }}>
          <IconButton
            aria-label='editar'
            size='medium'
            onClick={() => setShowBarcode(true)}
            title='imprimir código'
          >
            <img width='25px' src='/barcode-icon.svg' alt='' />
          </IconButton>
          <Box sx={{ fontSize: '10px' }}>{barcode}</Box>
        </Box>
      </TableCell>
      <TableCell>
        <StatusKey id={status_keys_id} str={status_keys_str} />
        <div className={classes.user_info}>
          {user_name && (
            <div className='mt-2'>
              <b>Usuario en préstamo: </b>
              <span>{user_name}</span>
            </div>
          )}
          {user_area && (
            <div>
              <b>Área usuario: </b>
              <span>{user_area}</span>
            </div>
          )}
          {user_email && (
            <div>
              <b>Email: </b>
              {user_email}
            </div>
          )}
          {user_phone && (
            <Button
              component='button'
              color='primary'
              variant='contained'
              href={`tel:${user_phone}`}
            >
              <AddIcCallIcon /> Llamar: {user_phone}
            </Button>
          )}
        </div>
        <Box sx={{ pt: 1, pb: 1, color: isExceededLoan ? 'red' : '#144D66' }}>
          <div className={housekey?.loan?.end_date ? 'mb-3' : ''}>
            {housekey?.loan?.created && (
              <Chip
                className='mr-3 bg'
                icon={<AccessAlarmsIcon />}
                label={`Registro: ${fullTime(housekey?.loan?.created)}`}
                clickable={false}
              />
            )}
            {housekey?.loan?.end_date && (
              <Chip
                style={
                  isExceededLoan
                    ? { background: '#b92929', color: 'white' }
                    : undefined
                }
                icon={
                  <AccessAlarmsIcon
                    style={isExceededLoan ? { color: 'white' } : undefined}
                  />
                }
                label={`Expiración: ${relativeFutureTime(
                  housekey?.loan?.end_date
                )}`}
                clickable={false}
              />
            )}
          </div>
          <ul className='list-disc pl-4'>
            <li>
              <b>Rack:</b> {housekey?.drawer?.rack}
            </li>
            <li>
              <b>Gaveta:</b> #{housekey?.drawer?.id}
            </li>
            <li>
              <b>Sección:</b> #{housekey?.drawer?.row}-
              {housekey?.drawer?.column}
            </li>
          </ul>
        </Box>
      </TableCell>
      <TableCell component='th' scope='row'>
        {created_at ? moment(created_at).format('DD/MM/YYYY HH:mm A') : ''}
      </TableCell>
      <TableCell align='right'>
        <div className='flex items-center justify-end'>
          {status_keys_id === 1 && allowEdit && (
            <IconButton
              aria-label='editar'
              size='medium'
              onClick={() => redirectEdition(housekey?.id)}
            >
              <Edit color='action' />
            </IconButton>
          )}
          {auth.type === RolesIds.Administrator && (
            <IconButton
              className='!ml-2'
              aria-label='borrar'
              size='medium'
              onClick={() => {
                Swal.fire({
                  title: '¿Quieres eliminar esta llave?',
                  text: 'Esta acción no se puede revertir.',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#FF5958',
                  cancelButtonColor: '#C0BFC2',
                  confirmButtonText: 'Si',
                  cancelButtonText: 'No',
                }).then((result) => {
                  if (result.value) {
                    deleteKey();
                  }
                });
              }}
            >
              <Delete />
            </IconButton>
          )}
          <button
            className={`relative ml-2 inline-flex items-center px-4 py-3 font-semibold leading-6 text-sm shadow rounded-md text-sky-500 bg-white  transition ease-in-out duration-150 ring-1 ring-slate-900/10`}
            aria-label='editar'
            onClick={() => openCommentHandler(housekey?.id)}
          >
            <CommentIcon color='action' />
            {comments_number > 0 && (
              <div className='flex items-center justify-center rounded-full ml-2 bg-gray-300 px-4 py-0.5'>
                <span className='mr-2 text-purple-700'>{comments_number}</span>
                <span className='relative flex h-4 w-4'>
                  <span className='animate-ping absolute inline-flex h-full w-full rounded-full bg-purple-400 opacity-75' />
                  <span className='relative inline-flex rounded-full h-4 w-4 bg-purple-500' />
                </span>
              </div>
            )}
          </button>
        </div>
      </TableCell>
      {showBarcode && (
        <ModalBarcode
          barcode={barcode}
          nid={properties_nid}
          onClose={() => setShowBarcode(false)}
        />
      )}
      {selectedHouseKeyId && (
        <HouseKeyComments
          housekey_id={selectedHouseKeyId}
          housekey_code={barcode}
          open
          onClose={closeCommentHandler}
        />
      )}
    </TableRow>
  );
};

export default HousekeyRow;
